import { autorun } from 'mobx';
import * as React from 'react';
import * as mapboxgl from 'mapbox-gl';
const useOwnLocationMarker = (map, positionWatcher, className) => {
    React.useEffect(() => {
        if (!map || !positionWatcher)
            return;
        let marker = undefined;
        const disposer = autorun(() => {
            const position = positionWatcher.position;
            const lngLat = position ? [position.coords.longitude, position.coords.latitude] : undefined;
            if (lngLat && !marker) {
                const el = document.createElement('div');
                el.className = className;
                marker = (new mapboxgl.Marker(el))
                    .setLngLat(lngLat)
                    .addTo(map);
            }
            if (!lngLat && marker) {
                marker.remove();
            }
            if (marker && lngLat) {
                marker.setLngLat(lngLat);
            }
        });
        return () => {
            if (marker)
                marker.remove();
            disposer();
        };
    }, [map, positionWatcher]);
};
export default useOwnLocationMarker;
